<template>
    <div class="ruta-form">
        <div class="form-header">
            <span class="form-title h2">
                <i class="fa-solid fa-thumbtack"></i>
                Novedad
            </span>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">
            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarNovedad" novalidate>

                    <b-row class="mb-4">
                        <b-col cols="12">
                            <b-form-group label="descripcion" label-for="descripcion">
                                <b-form-textarea id="descripcion" v-model="form.descripcion"
                                    placeholder="Novedad presentada" rows="3" required />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="otros" label-for="otros">
                                <b-form-input id="otros" v-model="form.otros" placeholder="Información adicional"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="tipo Novedad Id" label-for="tipo_novedad_id">
                                <b-form-input id="tipo_novedad_id" v-model="form.tipo_novedad_id" placeholder="Ej: 1"
                                    required />
                            </b-form-group>
                        </b-col>

                    </b-row>


                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Ruta' }}
                        </b-button>
                    </div>

                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>



<script>
export default {
    name: 'FormularioNovedad',
    data() {
        return {
            loading: false,
            collapsed: true,
            form: {
                descripcion: '',
                otros: '',
                tipo_novedad_id: '',
            }
        }
    },
    props: {
        preCarga: {
            type: Object,
            default: null

        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        descripcion: val.descripcion ?? '',
                        tipo_novedad_id: val.tipo_novedad_id ?? '',
                        otros: val.otros ?? '',
                    };
                }
            }
        }
    },
    methods: {
        async registrarNovedad() {
            this.loading = true;

            const data = {
                ...this.form,
                tipo_novedad_id: parseInt(this.form.tipo_novedad_id)
            };

            console.log("Formulario enviado:", data);
            this.$emit('submit', data, 'CrearNovedad');

            this.loading = false;
        }
    }
}


</script>


<style scoped>
.ruta-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #ffffff;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}



.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
